@if (isMulti()) {
  <elcia-multi-dropdown
    [control]="control()"
    [items]="options()"
    [label]="'entity.product-types' | translate"
    [textField]="'name'"
    [valueField]="'id'"
  />
} @else {
  <elcia-dropdown
    [control]="control()"
    [items]="options()"
    [label]="'product.type' | translate"
    [textField]="'name'"
    [valueField]="'id'"
  />
}
